const SESSION_KEY = 'auth_session_revision'
let observedSession = window.localStorage.getItem(SESSION_KEY)
let invalidated = false

// A new revision also detects login-to-login changes (for example OAuth).
export function markAuthenticated() {
  observedSession = `${Date.now()}-${Math.random().toString(36).slice(2)}`
  window.localStorage.setItem(SESSION_KEY, observedSession)
  window.localStorage.setItem('isLogin', '1')
}

export function isAuthSessionInvalidated() {
  return invalidated
}

export function installAuthSessionSync({ router, clients, Cancel }) {
  const isProtectedPage = () => router.currentRoute.value.matched.some(
    record => record.meta.requiresAuth,
  )

  const redirect = () => {
    if (invalidated) return
    invalidated = true
    // Reload to discard all account-specific stores, caches and editor state.
    // Preserve the shared cookies: another tab may already be logged in again.
    window.location.replace(router.resolve({ name: 'workboard-view' }).href)
  }

  const checkSession = () => {
    if (invalidated) return false
    const currentSession = window.localStorage.getItem(SESSION_KEY)
    if (!isProtectedPage()) {
      if (router.currentRoute.value.name === 'login-view' && currentSession !== observedSession && window.localStorage.getItem('isLogin') === '1') {
        redirect()
        return false
      }
      observedSession = currentSession
      return true
    }
    if (currentSession !== observedSession || window.localStorage.getItem('isLogin') === '0') {
      redirect()
      return false
    }
    return true
  }

  window.addEventListener('storage', event => {
    if (event.storageArea !== window.localStorage) return
    if (event.key !== null && event.key !== SESSION_KEY && event.key !== 'isLogin') return
    if (router.currentRoute.value.name === 'login-view' && event.key === 'isLogin' && event.newValue === '1') {
      redirect()
      return
    }
    // Process logout even if a subsequent login has already overwritten storage.
    if (isProtectedPage() && (event.key === null || (event.key === 'isLogin' && event.newValue !== '1'))) {
      redirect()
      return
    }
    checkSession()
  })
  window.addEventListener('focus', checkSession)
  window.addEventListener('pageshow', checkSession)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkSession()
  })

  clients.forEach(client => {
    client.interceptors.request.use(config => {
      // Check storage before sending, even when the storage event is still queued.
      if (!checkSession()) {
        throw new Cancel('Authentication changed in another tab')
      }
      return config
    })
  })
}
